import { Box, Switch, Tooltip } from '@optiaxiom/react';

import { Tool } from '@frontend/types';

export default function ActivityStatusCell({
  tool,
  onToggleActive,
}: {
  tool: Tool;
  onToggleActive: (toolId: string, isDisabled: boolean) => void;
}) {
  return (
    <Tooltip content="System tools cannot be disabled" disabled={!tool.is_system_function}>
      <Box>
        <Switch
          disabled={tool.is_system_function}
          checked={!tool.is_disabled}
          onCheckedChange={() => onToggleActive(tool.function_id, tool.is_disabled)}
          aria-label={`Toggle ${tool.name} active state`}
        />
      </Box>
    </Tooltip>
  );
}
